import React, { useState } from 'react';
import { ExpandMore } from '@material-ui/icons';
import { Button, CircularProgress, Drawer, Popover } from '@material-ui/core';

import { hooks } from './hooks';

import useCStyles from './DropdownButton.styles';
import { storeStatusStatusOpts as SSSOpts } from '../../constants';

import type { DropdownButtonProps as Props } from './DropdownButton.types';

// +++++ DropdownButton
export function DropdownButton(props: Props): JSX.Element {
  const {
    primaryState,
    isSingleStore,
    isLarge = false,
    children = null,
    handleOnClick = () => undefined,
    isPartnerStateLoading = false,
  } = props;

  const isError = !SSSOpts[primaryState]?.status;
  const isErrorOrIsPartnerStateLoading = isError || isPartnerStateLoading;
  const dropdownBtnId = 'drop-down-button-store-status';
  const anchorEl = document.getElementById(dropdownBtnId);

  const [open, setOpen] = useState(false);

  const textIds = hooks.useTexts({ isSingleStore, status: primaryState });
  const classes = useCStyles({
    open,
    color: SSSOpts[primaryState]?.bgColor || '',
  });

  const handleClose = () => setOpen(false);

  const handleOpen = () => {
    if (isErrorOrIsPartnerStateLoading) return;
    handleOnClick();
    setOpen(true);
  };

  const StartIcon = () => {
    if (isErrorOrIsPartnerStateLoading) return <CircularProgress size='1rem' />;

    return (
      <div
        role='status'
        data-value={primaryState}
        className={classes.buttonStartIconAnimation}
      />
    );
  };

  return (
    <React.Fragment>
      <Button
        id={dropdownBtnId}
        onClick={handleOpen}
        startIcon={<StartIcon />}
        endIcon={isLarge ? <ExpandMore /> : null}
        classes={{
          root: classes.button,
          endIcon: classes.buttonEndIcon,
          startIcon: isErrorOrIsPartnerStateLoading
            ? ''
            : classes.buttonStartIcon,
        }}
      >
        {textIds.dropdownBtn}
      </Button>

      {isLarge && !isErrorOrIsPartnerStateLoading && (
        <Popover
          open={open}
          role='tooltip'
          anchorEl={anchorEl}
          onClose={handleClose}
          PaperProps={{ classes: { root: classes.popoverPaper } }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          {children}
        </Popover>
      )}

      {!isLarge && !isErrorOrIsPartnerStateLoading && (
        <Drawer
          open={open}
          anchor='bottom'
          onClose={handleClose}
          PaperProps={{ classes: { root: classes.drawerPaper } }}
        >
          {children}
          <Button
            size='large'
            variant='text'
            onClick={handleClose}
            classes={{ root: classes.drawerCloseBtn }}
          >
            {textIds.drawerCloseBtn}
          </Button>
        </Drawer>
      )}
    </React.Fragment>
  );
}
// ----- DropdownButton
